const ironAndFoldMan = [
	{
		id: '3101',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},
	{
		id: '3102',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Jeans / Pajama)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},
	{
		id: '3103',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blazer / Coat / Jacket',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 60,
		quantity: 1
	},
	{
		id: '3104',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
	},
	{
		id: '3105',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Waist Coat',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 50,
		quantity: 1
	},
	{
		id: '3106',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Inner Wear (Socks / Shorts / Under Shirt)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},
	{
		id: '3107',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Panjabi',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},
	{
		id: '3108',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Panjabi',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
	},
	{
		id: '3109',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Lather Jacket',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 500,
		quantity: 1
	},

	{
		id: '3110',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer + Trouser)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 100,
		quantity: 1
	},
	{
		id: '3111',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer + Trouser + Waist Coat)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 160,
		quantity: 1
	},
	{
		id: '3112',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Overcoat / Overall',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 300,
		quantity: 1
	},
	{
		id: '3113',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sherwani',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 350,
		quantity: 1
	},
	{
		id: '3114',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
	},
	{
		id: '3115',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Muffler / Scarf / Cap / Tie)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},
	{
		id: '3116',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Home Wear (Sleeping suit / Nightdress)',
		category: "Men's Wear",
		service: 'Iron And Fold',
		price: 15,
		quantity: 1
	}
];

export default ironAndFoldMan;
